import { Fragment, memo, MouseEventHandler, PropsWithChildren, ReactNode } from 'react';
import { BadgeOwnerState } from '@mui/material';

import { BackdropLoader } from '@/dmdrive/ui-kit/components';

import { ToolbarControlBadge, ToolbarControlIcon, ToolbarControlRoot } from './ToolbarControl.styles';

interface ToolbarControlProps {
  isActive?: boolean;
  isSquare?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  icon?: ReactNode;
  badgeContent?: ReactNode;
  badgeVariant?: BadgeOwnerState['variant'];
  onClick: MouseEventHandler<HTMLButtonElement>;
}

function ToolbarControl(props: PropsWithChildren<ToolbarControlProps>) {
  const {
    icon,
    isLoading = false,
    isActive = false,
    isSquare = false,
    isDisabled = false,
    children,
    onClick,
    badgeContent,
    badgeVariant,
  } = props;

  return (
    <ToolbarControlRoot
      disabled={isDisabled}
      isDisabled={isDisabled}
      isActive={isActive}
      isSquare={isSquare}
      onClick={onClick}
    >
      {isLoading && <BackdropLoader size={24} isLoading />}

      {!isLoading && (
        <Fragment>
          {icon && (
            <ToolbarControlIcon isActive={isActive}>
              <ToolbarControlBadge badgeContent={badgeContent} variant={badgeVariant} color="primary">
                {icon}
              </ToolbarControlBadge>
            </ToolbarControlIcon>
          )}

          <span>{children}</span>
        </Fragment>
      )}
    </ToolbarControlRoot>
  );
}

export default memo(ToolbarControl);
